import { render } from "./ReportsView.vue?vue&type=template&id=28bcc54d&scoped=true"
import script from "./ReportsView.vue?vue&type=script&lang=js"
export * from "./ReportsView.vue?vue&type=script&lang=js"

import "./ReportsView.vue?vue&type=style&index=0&id=28bcc54d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bcc54d"]])

export default __exports__